import script from "./mobile-page-header.vue?vue&type=script&setup=true&lang=js"
export * from "./mobile-page-header.vue?vue&type=script&setup=true&lang=js"

import "./mobile-page-header.vue?vue&type=style&index=0&id=75cc8ba5&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75cc8ba5"]])

export default __exports__